// extracted by mini-css-extract-plugin
export default {"slide_container":"index_slide_container_p9UhS","dot":"index_dot_UhcQy","current":"index_current_c-k4D"};